/**
 * Speaker section — 1 variant (spotlight)
 * 一人の登壇者にフォーカスする構成。
 */
import type { SpeakerContent } from '../schemas/speaker';
import {
  Body,
  Eyebrow,
  H2,
  SectionFrame,
  VisualPlaceholder,
} from './primitives';

interface SpeakerProps {
  content: SpeakerContent;
}

export function SpeakerSpotlight({ content }: SpeakerProps) {
  return (
    <SectionFrame background="surface">
      <div
        className="ls-split-pair"
        style={{ gridTemplateColumns: '1fr 1.4fr', gap: 56 }}
      >
        <div className="ls-split-media">
          <VisualPlaceholder
            src={content.avatar}
            aspectRatio="3 / 4"
            label={content.name}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {content.eyebrow && <Eyebrow>{content.eyebrow}</Eyebrow>}
          <H2 style={{ fontSize: 'clamp(1.75rem, 3vw + 0.5rem, 2.75rem)' }}>
            {content.name}
          </H2>
          <div
            style={{
              fontSize: '1.0625rem',
              color: 'var(--ls-accent)',
              fontWeight: 600,
            }}
          >
            {content.title}
          </div>
          {content.subTitle && (
            <div style={{ fontSize: '0.95rem', color: 'var(--ls-text-muted)' }}>
              {content.subTitle}
            </div>
          )}
          <Body style={{ whiteSpace: 'pre-line', marginTop: 8 }}>
            {content.bio}
          </Body>
        </div>
      </div>
    </SectionFrame>
  );
}

export function SpeakerCardCentered({ content }: SpeakerProps) {
  return (
    <SectionFrame>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          maxWidth: 720,
          margin: '0 auto',
          gap: 20,
        }}
      >
        {content.eyebrow && <Eyebrow>{content.eyebrow}</Eyebrow>}
        <div style={{ width: 200 }}>
          <VisualPlaceholder
            src={content.avatar}
            aspectRatio="1 / 1"
            label={content.name}
            className="ls-speaker-avatar"
          />
        </div>
        <H2 style={{ fontSize: 'clamp(1.5rem, 2.5vw + 0.5rem, 2.25rem)' }}>
          {content.name}
        </H2>
        <div
          style={{
            fontSize: '1rem',
            color: 'var(--ls-accent)',
            fontWeight: 600,
          }}
        >
          {content.title}
        </div>
        {content.subTitle && (
          <div style={{ fontSize: '0.9rem', color: 'var(--ls-text-muted)' }}>
            {content.subTitle}
          </div>
        )}
        <Body style={{ whiteSpace: 'pre-line' }}>{content.bio}</Body>
      </div>
    </SectionFrame>
  );
}

export const speakerVariants = {
  spotlight: SpeakerSpotlight,
  card_centered: SpeakerCardCentered,
};
